import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, from } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthenticationService } from '@aveva/connect-web-core';
import * as globals from '../training/globals';

const baseUrl = `${environment.apis.connect}/${globals.IMPORTS}`;

@Injectable({
  providedIn: 'root',
})

export class ImportsService {
  constructor(
    private http: HttpClient) { }

  createImport(data: any): Observable<boolean> {
    return this.http.post<boolean>(`${baseUrl}/${globals.CREATE_IMPORT}`, data);
  }

  getImport(import_id: number): Observable<any> {
    return this.http.get(`${baseUrl}/${globals.GET_IMPORT}?import_id=${import_id}`);
  }

  queryImports(): Observable<any> {
    return this.http.get(`${baseUrl}/${globals.QUERY_IMPORTS}`);
  }

}
